import { IPoppulatedMag } from 'pages/salarie/autresInformations/aptarMag/aptarMag'
import { ReactNode, useEffect, useState } from 'react'
import AliceCarousel from 'react-alice-carousel'
import getMonth from 'utils/getMonth'
import './projetsCarousel.scss'

interface IProps {
   items: IPoppulatedMag[]
   onImageClick: (mag: IPoppulatedMag) => void
}

export default function ProjetCarousel(props: IProps) {
   const [sortedItems, setSortedItems] = useState<ReactNode[]>([])

   useEffect(() => {
      setSortedItems(props.items.map((item, index) => {
         const formatedDate = item.mois ? new Date(item.mois[0].value) : undefined
         return (
            <div
               key={index}
               className='carousel-item'
               onClick={() => {
                  props.onImageClick(item)
               }}
            >
               {formatedDate && <div className='carousel-text'>{`${getMonth(formatedDate.getMonth())} ${formatedDate.getFullYear()}`}</div>}
               <br />
               {item.pages && <img src={item.pages[0].value} className='carousel-image' />}
            </div>
         )
      }))
   }, [props.items])

   return (
      <div id='projetCarousel'>
         <AliceCarousel
            animationDuration={600}
            autoPlay={false}
            items={sortedItems}
            animationType='slide'
            autoPlayControls
            renderPrevButton={() => {
               return <img style={{height: "50px"}} src={`${process.env.PUBLIC_URL}/img/flecheGauche.png`} alt='Prev' />
            }}
            renderNextButton={() => {
               return <img style={{height: "50px"}} src={`${process.env.PUBLIC_URL}/img/flecheDroite.png`} alt='Next' />
            }}
         />
      </div>
   )
}
